import React from 'react';
import {ButtonBar, SaveButton, Field, Form, Option, Split} from '../commons/Forms.js';
import {Pane, Part} from '../commons/Panes';
import {connect} from 'react-redux';
import {addSkiresort} from '../../redux/skiresorts/actions';
import {validateEmail} from '../../utils';
import '../../styles/adminPanels.less';
import {OverlayTrigger, Tooltip} from "react-bootstrap";

/** Panneau d'ajout d'une station */
@connect(
  () => ({}),
  {addSkiresort}
)
class SkiresortAdd extends React.Component {

  async onSubmit(e) {
    e.preventDefault();

    let data = {
      country: this.refs.country.value(),
      logoUrl: this.refs.logoUrl.value(),
      name: this.refs.name.value(),
      user: {
        api_token: this.refs.api_token.value(),
        name: `User_${this.refs.name.value()}`
      },
      latitude: +this.refs.latitude.value(),
      longitude: +this.refs.longitude.value(),
      openingDate: this.refs.openingDate.value(),
      closingDate: this.refs.closingDate.value(),
      assignees: this.refs.assignees.value(),
      csvBeacon: null,
      csvArea: null
    };

    if (this.refs.csvBeacon.value() !== undefined) {
      data.csvBeacon = await this.csvToBase64(this.refs.csvBeacon.value());
    }
    if (this.refs.csvArea.value() !== undefined) {
      data.csvArea = await this.csvToBase64(this.refs.csvArea.value());
    }

    this.props.addSkiresort(data);
    this.props.onEnd();
    return false;
  }

  csvToBase64(csvFile) {
    let reader = new FileReader();
    return new Promise((resolve) => {
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(csvFile);
    });
  }

  render() {
    let theForm = (
      <Form onSubmit={e => this.onSubmit(e)}>
        <Field ofType="select" label="Pays" required={true} ref="country">
          <Option value="Italie"/>
          <Option value="France"/>
          <Option value="Suisse"/>
        </Field>
        <Field ofType="textarea" label="URL (ou base64) du logo" required={false} ref="logoUrl"/>
        <OverlayTrigger overlay={
          <Tooltip id="tooltip" className='tooltip'>
            <span>Une image encod&eacute;e en base 64 doit commencer par `data:image/&lt;format-de-l'image&gt;;base64`. Vous pouvez vous aider de convertisseur d'image en base64 en ligne.</span>
          </Tooltip>
        } placement="left">
          <i className="notice">Qu'est-ce qu'une base64 ?</i>
        </OverlayTrigger>
        <Field ofType="text" label="Nom" required={true}
               validateWith="min3" ref="name"/>
        <Split>
          <Field ofType="text" label="Latitude" required={false}
                 validateWith="latitude" ref="latitude"/>
          <Field ofType="text" label="Longitude" required={false}
                 validateWith="longitude" ref="longitude"/>
        </Split>
        <Field ofType="textarea" label="Responsables" required={false}
               ref="assignees"
               validateWith={data => data.split('\n').every(m => validateEmail(m))}
               validationError="Veuillez entrer une adresse e-mail valide"/>
        <Field ofType="file" label="CSV des points d'ancrage" required={false} ref="csvBeacon"/>
        <Field ofType="file" label="CSV des zones" required={false} ref="csvArea"/>
        <Split>
          <Field ofType="date" label="Ouverture" required={true}
                 ref="openingDate"/>
          <Field ofType="date" label="Fermeture" required={true}
                 ref="closingDate"/>
        </Split>
        <Field ofType="text" label="Code d'accès" required={true}
               validateWith="min3" ref="api_token"/>
        <ButtonBar>
          <SaveButton/>
        </ButtonBar>
      </Form>
    );

    return (
      <Pane title="Ajout d'une station">
        <Part title="Station">
          {theForm}
        </Part>
      </Pane>
    )
  }
}


export default SkiresortAdd;



// WEBPACK FOOTER //
// ./src/components/admin/SkiresortAdd.js